import React from 'react';

export default class AppErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[AppErrorBoundary]', error, info?.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24,
            background: '#0b0c10',
            color: '#e4e4e7',
            fontFamily: 'system-ui, sans-serif',
          }}
        >
          <div style={{ maxWidth: 520 }}>
            <h1 style={{ fontSize: 22, marginBottom: 8 }}>Erro ao carregar o SAMPRO</h1>
            <p style={{ color: '#a1a1aa', marginBottom: 16 }}>
              Algo quebrou na interface. Tente recarregar a página (Cmd+Shift+R).
            </p>
            <pre
              style={{
                background: '#18181b',
                border: '1px solid #3f3f46',
                borderRadius: 8,
                padding: 12,
                fontSize: 12,
                overflow: 'auto',
                whiteSpace: 'pre-wrap',
              }}
            >
              {this.state.error?.message || String(this.state.error)}
            </pre>
            <button
              type="button"
              onClick={() => window.location.reload()}
              style={{
                marginTop: 16,
                padding: '10px 18px',
                borderRadius: 8,
                border: 'none',
                background: 'linear-gradient(135deg,#6366f1,#7c3aed)',
                color: '#fff',
                fontWeight: 700,
                cursor: 'pointer',
              }}
            >
              Recarregar
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
